import { IResponderPesquisaSatisfacao } from "../../../Interfaces/Geral/Formularios/FormulariosInterface";
import {
    ListarFormularioEPerguntaRespostasPesquisaSatisfacaoService,
    ResponderPesquisaSatisfacaoService,
} from "../../../Services/Geral/ResponderPesquisaSatisfacao/ResponderPesquisaSatisfacaoService";
import { Controller } from "../../Controller";

export async function ResponderPesquisaSatisfacaoController(
    idContaChat: number,
    idOrganizacao: string,
    requestBody: IResponderPesquisaSatisfacao
) {
    return Controller(
        ResponderPesquisaSatisfacaoService(
            idContaChat,
            idOrganizacao,
            requestBody
        )
    );
}

export async function ListarFormularioEPerguntaRespostasPesquisaSatisfacaoController(
    idFormulario: number,
    idOrganizacao: string
) {
    return Controller(
        ListarFormularioEPerguntaRespostasPesquisaSatisfacaoService(
            idFormulario,
            idOrganizacao
        )
    );
}
